import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';

import UsersDataTable from './components/UsersDataTable/UsersDataTable';

const useStyles = makeStyles((theme) => ({
	root: {},
	deliverables: {
		marginTop: theme.spacing(3),
	},
	members: {
		marginTop: theme.spacing(3),
	},
}));

const Users = (props) => {
	const { users, className, ...rest } = props;

	const classes = useStyles();
	return (
		<Grid
			{...rest}
			className={clsx(classes.root, className)}
			container
			spacing={3}
		>
			<Grid item lg={12} md={12} xl={23} xs={12}>
				<UsersDataTable data={users} />
			</Grid>
		</Grid>
	);
};

Users.propTypes = {
	className: PropTypes.string,
	users: PropTypes.array.isRequired,
};

export default Users;
